import { Dispatch, SetStateAction } from 'react';
import { TSectionAnchor, INavLinks } from '../../settings';
import { setHash } from '../../utils';

export const DATA_AS_NAV_TAB_ATTR = 'data-as-nav-tab';

export function getNavLinksFromSections(): INavLinks[] {
  const sections = document.querySelectorAll<HTMLElement>(`section[id][${DATA_AS_NAV_TAB_ATTR}]`);

  if (sections.length < 1) {
    return [];
  }

  return Array.from(sections).reduce((accumulator, section) => {
    const id = section.getAttribute('id');
    const title = section.getAttribute(DATA_AS_NAV_TAB_ATTR);

    if (title && id) {
      accumulator.push({
        value: id as TSectionAnchor,
        title,
        offsetTop: section.offsetTop,
        offsetHeight: section.offsetHeight,
      });
    }

    return accumulator;
  }, Array.of<INavLinks>());
}

export function updateActiveSection(sections: INavLinks[], onActiveSection: Dispatch<SetStateAction<TSectionAnchor>>) {
  if (sections.length < 1) {
    return;
  }

  const scrollY = window.pageYOffset;

  sections.forEach(section => {
    const sectionTop = section.offsetTop - 100;

    if (section.value && scrollY > sectionTop && scrollY <= sectionTop + section.offsetHeight) {
      onActiveSection(section.value as TSectionAnchor);
      setHash(section.value);
    }
  });
}
